import {
  AcceptCompanyInvitationInput,
  AppleLoginInput,
  AppleLoginPayload,
  FacebookLoginInput,
  FacebookLoginPayload,
  GetUserQuery,
  GoogleLoginInput,
  GoogleLoginPayload,
  ObtainJsonWebTokenPayload,
  RegisterUserInput,
} from '@Graphql/graphqlTypes.generated';
import { LoadableItem, LoadableItemWithValue, LocationReferer, PayloadWithPromises } from '@Utils/types';

export interface LoginFormData {
  email: string;
  password: string;
}

export interface RegisterFormData {
  email: string;
  username: string;
  password: string;
  terms: boolean;
}

export interface ResetPasswordFormFormData {
  email: string;
}

export interface LoginActionData {
  email: string;
  password: string;
  referer?: string;
}

export interface InvitationKeyPayload {
  invitationKey: string;
}

export interface LoginActionPayload extends LoginActionData, PayloadWithPromises {}

export interface RegisterActionPayload extends PayloadWithPromises, RegisterUserInput {}

export interface LoginActionSuccess {
  params: LoginActionPayload | FacebookLoginInputPayload | AppleLoginInputPayload | GoogleLoginInputPayload;
  result: FacebookLoginPayload | GoogleLoginPayload | AppleLoginPayload | ObtainJsonWebTokenPayload;
}

export interface FacebookLoginInputPayload extends FacebookLoginInput, LocationReferer {}

export interface GoogleLoginInputPayload extends GoogleLoginInput, LocationReferer {}

export interface AppleLoginInputPayload extends AppleLoginInput, LocationReferer {}

export interface AcceptCompanyInvitationInputPayload extends AcceptCompanyInvitationInput, LocationReferer {}

export type UserData = LoadableItem<GetUserQuery['me']>;

export type UserWithData = LoadableItemWithValue<GetUserQuery['me']>;

export const isUserWithData = (user: UserData): user is UserWithData => {
  return !!user.item;
};

export type UserActiveCompany = GetUserQuery['me']['info']['activeCompany'];

export type FacebookAuthResponse = {
  status?: FacebookAuthResponseStatus;
  userID: string;
  accessToken: string;
  email: string;
  id: string;
  name: string;
};

export enum FacebookAuthResponseStatus {
  unknown = 'unknown',
}

export type AppleAuthResponse = {
  authorization: {
    code: string;
    id_token: string;
  };
  user?: {
    email: string;
    name: {
      firstName: string;
      lastName: string;
    };
  };
  access_token?: string;
  token_type?: string;
  expires_in?: number;
};

export interface ChangeLanguagePayload {
  lang: string;
}
